/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const encounterClinicalFindings = sqliteTable('encounter_clinical_findings', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  encounter_id: text('encounter_id'),
  text: text('text'),
  teeth: text('teeth'),
  source: text('source'),
  source_ref: text('source_ref'),
  condition_code: text('condition_code'),
  sort_order: integer('sort_order'),
  created_by_user_id: text('created_by_user_id'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  updated_by: text('updated_by'),
});
